import { render, staticRenderFns } from "./WriterSidebarContainer.vue?vue&type=template&id=bfc65a66&"
import script from "./WriterSidebarContainer.vue?vue&type=script&lang=js&"
export * from "./WriterSidebarContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports